// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://axqzenckmooiqqippzib.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF4cXplbmNrbW9vaXFxaXBwemliIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY3MTc2OTMsImV4cCI6MjA3MjI5MzY5M30.aKmdnNOmt7yME9FvkwXZoSDy2WH660GEYXaxPOB-NsA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});